module.exports = {"year":{"one":"{0} год","many":"{0} лет","other":"{0} года"},"month":{"one":"{0} месяц","many":"{0} месяцев","other":"{0} месяца"},"week":{"one":"{0} неделю","many":"{0} недель","other":"{0} недели"},"day":{"one":"{0} день","few":"{0} дня","other":"{0} дней"},"hour":{"one":"{0} час","many":"{0} часов","other":"{0} часа"},"minute":{"one":"{0} минута","many":"{0} минут","other":"{0} минуты"},"second":{"one":"{0} секунда","many":"{0} секунд","other":"{0} секунды"},"now":{"past":"только что","future":"сейчас"}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/locale-more-styles/ru/long-time.json
// module id = 690
// module chunks = 0